import {
  IProductAdvancedSettingsInput,
  ProductQuantityDisplayTypeEnum,
  ProductResWithMandatory,
} from '@monetize/types/app';

export const productHasAdvancedSettings = ({
  quantityDisplayType,
  isPriceTierLockEligible,
}: Pick<
  ProductResWithMandatory,
  'quantityDisplayType' | 'isPriceTierLockEligible'
>): boolean =>
  quantityDisplayType === ProductQuantityDisplayTypeEnum.DROPDOWN ||
  !!isPriceTierLockEligible;

export const getDrawerGridTemplate = (
  showQuantityDropdown: boolean,
  showPriceTierLock: boolean,
) => {
  if (showQuantityDropdown && showPriceTierLock) {
    return '1fr 130px 130px';
  }
  if (showQuantityDropdown || showPriceTierLock) {
    return '1fr 230px';
  }
  return '1fr';
};

export const buildFormValues = (
  products: ProductResWithMandatory[],
): IProductAdvancedSettingsInput => ({
  products: products.map(
    ({ quantityDisplayType, isPriceTierLockEligible }) => ({
      quantityDisplayType:
        quantityDisplayType ?? ProductQuantityDisplayTypeEnum.INPUT,
      isPriceTierLockEligible: isPriceTierLockEligible ?? false,
    }),
  ),
});
